import React from "react"
import clsx from "clsx"
import { Tab, Tabs, makeStyles } from "@material-ui/core"
import { OrdersPeriod } from "shared/Modules/OrdersSummary/ordersSummaryTypes"
import { LocalizedEnum } from "shared/Modules/Localization/Components/Localized"
import { getOrdersSummary } from "shared/Modules/OrdersSummary/ordersSummaryApi"
import { useQuery } from "shared/Modules/Query/useQuery"
import { useToken } from "shared/Modules/Login/useToken"
import ExpensesGraph from "./ExpensesGraph"

const useStyles = makeStyles((theme) => ({
    tabs: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    tab: {
        fontWeight: "normal",
        borderColor: "transparent",
    },
    activeTab: {
        fontWeight: "bold",
    },
}))

export type ExpensesTabsProps = Readonly<{
    activeTab: number
    activePeriod: OrdersPeriod
    onTabSwitch: (newIndex: number) => void
}>

export function ExpensesTabs({ activeTab, activePeriod, onTabSwitch }: ExpensesTabsProps) {
    const token = useToken()
    const classes = useStyles()

    const { QueryPane } = useQuery(() => getOrdersSummary(activePeriod, token), [activePeriod, token])

    return (
        <>
            <Tabs value={activeTab} indicatorColor="primary" className={classes.tabs}>
                {Object.keys(OrdersPeriod).map((tab, index) => (
                    <LocalizedEnum base="my-orders-expenses-chart-tab" enumValue={tab} attrs={{ label: true }}>
                        <Tab
                            label={tab}
                            onClick={() => onTabSwitch(index)}
                            className={clsx(classes.tab, activeTab === index && classes.activeTab)}
                        />
                    </LocalizedEnum>
                ))}
            </Tabs>
            <QueryPane>{(data) => <ExpensesGraph report={data.expensesReport} />}</QueryPane>
        </>
    )
}
